export const loadLocaleData = locales => {
  const initialLocaleState = {
    en: {},
    ru: {},
    am: {}
  };
  for (const key in locales) {
    const { ru, en, am } = locales[key];
    initialLocaleState.en[key] = en;
    initialLocaleState.ru[key] = ru;
    initialLocaleState.am[key] = am;
  }
  return initialLocaleState;
};
